export default {
  list: [
    {
      title: 'همه کاربرها',
      value: 'ALL_USERS'
    },
    {
      title: 'کاربرهای خاص',
      value: 'SPECIAL_USERS'
    },
    {
      title: 'افرادی با حداقل رزرو موفق',
      value: 'HAS_MIN_SUCCESSFUL_RESERVATION'
    },
    {
      title: 'افرادی با حداقل سفارش در رزروهای خود',
      value: 'HAS_MIN_ORDER_IN_RESERVATION'
    },
    {
      title: 'کاربران کد تخفیف',
      value: 'DISCOUNT_CODE_USERS'
    }
  ],
  values: {
    ALL_USERS: 'ALL_USERS',
    DISCOUNT_CODE_USERS: 'DISCOUNT_CODE_USERS',
    HAS_MIN_SUCCESSFUL_RESERVATION: 'HAS_MIN_SUCCESSFUL_RESERVATION',
    HAS_MIN_ORDER_IN_RESERVATION: 'HAS_MIN_ORDER_IN_RESERVATION',
    SPECIAL_USERS: 'SPECIAL_USERS'
  }
}